import { render, staticRenderFns } from "./SelectNosologies.vue?vue&type=template&id=101fba0f&scoped=true&"
import script from "./SelectNosologies.vue?vue&type=script&lang=js&"
export * from "./SelectNosologies.vue?vue&type=script&lang=js&"
import style0 from "./SelectNosologies.vue?vue&type=style&index=0&id=101fba0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101fba0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
